import { t } from '../../../../../services/texts.service';
import { createElementHook, createControlHook, createLeafComponent } from '@react-leaflet/core';
import type { LeafletContextInterface } from '@react-leaflet/core';
import L from 'leaflet';

interface FeedbackControlProps {
  className: string;
  position?: 'topleft' | 'topright' | 'bottomleft' | 'bottomright';
  onClick?: () => void;
}

function createFeedbackControl({ className, position = 'bottomleft', onClick }: FeedbackControlProps, context: LeafletContextInterface) {
  const controlInstance = new L.Control({ position });

  controlInstance.onAdd = () => {
    const div = L.DomUtil.create('div', `leaflet-bar ${className ?? ''}`);
    const hyperlink = L.DomUtil.create('a', 'leaflet-bar-part leaflet-bar-part-single w-auto px-2');
    hyperlink.href = '#';
    hyperlink.setAttribute('role', 'button');
    hyperlink.onclick = (e) => {
      e.preventDefault();
      onClick?.();
    };
    const label = L.DomUtil.create('span', 'leaflet-control-feedback-icon d-flex align-items-center gap-1', hyperlink);
    label.textContent = t('Berätta vad du tycker', 'Tell us what you think');
    div.appendChild(hyperlink);
    return div;
  };

  return { instance: controlInstance, context };
}

function updateFeedbackControl(instance: L.Control, props: FeedbackControlProps, prevProps: FeedbackControlProps) {
  if (props.className === prevProps.className) return;
  const container = instance.getContainer();
  if (!container) return;
  const prev = prevProps.className?.split(' ').filter(Boolean) ?? [];
  const next = props.className?.split(' ').filter(Boolean) ?? [];
  if (prev.length) container.classList.remove(...prev);
  if (next.length) container.classList.add(...next);
}

const useFeedbackControlElement = createElementHook(createFeedbackControl, updateFeedbackControl);
const useFeedbackControl = createControlHook(useFeedbackControlElement);
const FeedbackControlComponent = createLeafComponent(useFeedbackControl);

export default FeedbackControlComponent;
